module.exports = __webpack_public_path__ + "img/s12-dialog.25519073.png";